"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeRanges = void 0;
var TimeRanges;
(function (TimeRanges) {
    TimeRanges["HOURS_24"] = "24hours";
    TimeRanges["DAYS_3"] = "3days";
    TimeRanges["DAYS_7"] = "7days";
})(TimeRanges || (exports.TimeRanges = TimeRanges = {}));
